import { ButtonHTMLAttributes, ReactNode } from "react"

type ActionButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "type"> & {
  label: string
  icon: ReactNode
}

// Icon button, the label is the tooltip and the name for screen readers.
// The colour classes come in through className.
export default function ActionButton({ label, icon, className = "", title, ...props }: ActionButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      title={title ?? label}
      className={`inline-flex items-center justify-center rounded-md px-2.5 py-2 text-xs font-medium transition active:scale-[0.98] ${className}`}
      {...props}
    >
      <span aria-hidden="true">{icon}</span>
    </button>
  )
}
